import react from "react";

export default function SectionCard({ title, right, children }) {
  return (
    <div className="bg-white/95 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-slate-100/80 p-4 flex flex-col h-full">
      <div className="flex items-center justify-between mb-3 gap-2">
        <h2 className="text-sm font-semibold text-slate-700 flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />
          {title}
        </h2>
        {right}
      </div>
      <div className="flex-1">{children}</div>
    </div>
  );
}